// extracted by mini-css-extract-plugin
export default {"client-profile-content":"client-profile-alert-settings_client-profile-content__sh2pa"};